export const MULTIPART_HEADERS = {
  Accept: 'multipart/formData',
}

export const COMPANY_TYPES = [
  'Distribucija',
  'Servis',
  'Proizvodnja',
  'Proizvodnja po narudzbi',
]

export const MESSAGE_TYPE = {
  private: 'private',
  product: 'product',
  request: 'request',
}

export const USER_ROLES = {
  user: 'user',
  admin: 'admin',
}

export const NUM_OF_EMPLOYEES_OPTIONS = [
  '1-5',
  '6-10',
  '11-20',
  '21 - 50',
  '51-100',
  '101-200',
  '201-500',
  '500+',
]
